<template>
  <div>
    <top-bar/>
    <div class="content mt-5">
      <div class="container">
        <div class="row justify-content-center align-items-center">
          <div class="col-md-6">
            <auth-login-form
              title="Adicionar conta"
              subtitle="Informe seu usuário de acesso"
              submit-label="Continuar"
              :show-unknown-user-link="false"
              :show-recover-link="false"
              :allow-recovery-redirect="false"
              :can-submit="empresas.length < 3"
              blocked-message="No momento é possível adicionar no máximo 3 contas."
              card-style="max-width: 420px"
              @authenticated="handleAuthenticated"
            />
            <div class="text-center mt-3">
              <router-link to="/configs" class="text-decoration-none">Voltar para Configs</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthLoginForm from '@/components/auth/AuthLoginForm.vue'
import TopBar from '@/components/commons/TopBar.vue'

export default {
  name: 'Empresas',
  components: { TopBar, AuthLoginForm },
  data() {
    return {
      token: "",
      empresas: []
    }
  },
  methods: {
    handleAuthenticated({ data }) {
      const key = data.token;

      if (this.empresas.find(e => e.key === key) || this.empresas.find(e => e.id_empresa === data.id_empresa)) {
        this.$swal('Você já está logado, faça o login em outra conta ou volte ao menu principal.');
        return;
      }

      this.empresas.push({ key, token: '', isDefault: false });
      localStorage.setItem('empresas', JSON.stringify(this.empresas));
      window.location.href = "/configs";

      if (this.isElectron) {
        window.control.fechar({ reiniciar: true });
      }
    }
  },

  created() {
    this.token = localStorage.getItem('token');
    this.empresas = localStorage.getItem('empresas') ? JSON.parse(localStorage.getItem('empresas')) : [];
  }
}
</script>
<style scoped>
</style>
